<div class="acv-wrap">

  @if (loading) {
    <div class="acv-skeleton">
      <div class="acv-sk-title"></div>
      <div class="acv-sk-row"></div>
      <div class="acv-sk-bar"></div>
      @for (_ of [1,2,3,4,5]; track $index) { <div class="acv-sk-row"></div> }
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="acv-header">
      <span class="acv-title">Cobertura de área visual</span>
      <span class="acv-subtitle">
        Área bruta de bounding boxes por tag · imagen de referencia {{ formatArea(totalImageArea) }}
        @if (overlapWarning) {
          <span class="acv-overlap-warn" title="Los objetos se solapan — el total supera el 100%">
            ⚠ overlapping detectado
          </span>
        }
      </span>
    </div>

    <!-- KPI cards por tag -->
    <div class="acv-kpi-row">
      @for (t of tagCoverages; track trackByKey($index, t)) {
        <div class="acv-kpi" [style.--tc]="t.color" [style.--bg]="t.bg">
          <span class="acv-kpi__tag" [style.color]="t.color">{{ t.label }}</span>
          <span class="acv-kpi__pct">{{ t.areaPct }}%</span>
          <span class="acv-kpi__area">{{ formatArea(t.areaPx) }}</span>
          <div class="acv-kpi__bar">
            <div class="acv-kpi__bar-fill"
                 [style.width.%]="t.barW"
                 [style.background]="t.color">
            </div>
          </div>
          <span class="acv-kpi__objs">{{ t.objCount }} objetos · avg {{ formatArea(t.avgArea) }}/obj</span>
        </div>
      }
    </div>

    <!-- Stacked bar total -->
    <div class="acv-stack-wrap">
      <span class="acv-stack-label">Distribución de área</span>
      <div class="acv-stack-bar">
        @for (seg of stackSegments; track $index) {
          <div class="acv-stack-seg"
               [style.flex]="seg.pct"
               [style.background]="seg.color"
               [title]="seg.label + ': ' + seg.pct + '%'">
            @if (seg.pct >= 8) {
              <span>{{ seg.label }} {{ seg.pct }}%</span>
            }
          </div>
        }
      </div>
    </div>

    <!-- Tabla top objetos por área -->
    <div class="acv-table-section">
      <div class="acv-table-header">
        <span class="acv-table-title">Objetos con mayor área visual</span>
      </div>

      <table class="acv-table">
        <thead>
          <tr>
            <th class="acv-th">#</th>
            <th class="acv-th acv-th--name">Objeto</th>
            <th class="acv-th">Tag</th>
            <th class="acv-th">Área total</th>
            <th class="acv-th">% imagen</th>
            <th class="acv-th">Detecciones</th>
            <th class="acv-th">Área prom.</th>
            <th class="acv-th acv-th--bar">Peso visual</th>
          </tr>
        </thead>
        <tbody>
          @for (row of objectRows; track trackByName($index, row)) {
            <tr class="acv-tr">
              <td class="acv-td acv-td--rank">{{ $index + 1 }}</td>
              <td class="acv-td acv-td--name" [title]="row.name">{{ row.name }}</td>
              <td class="acv-td">
                <span class="acv-tag-pill"
                      [style.background]="row.tagBg"
                      [style.color]="row.tagColor">
                  {{ row.tagLabel }}
                </span>
              </td>
              <td class="acv-td acv-td--num">{{ formatArea(row.areaPx) }}</td>
              <td class="acv-td acv-td--num acv-td--pct">{{ row.areaPct }}%</td>
              <td class="acv-td acv-td--num">{{ row.count }}</td>
              <td class="acv-td acv-td--num">{{ formatArea(row.avgArea) }}</td>
              <td class="acv-td acv-td--bar-cell">
                <div class="acv-bar">
                  <div class="acv-bar__fill"
                       [style.width.%]="row.barW"
                       [style.background]="row.tagColor">
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (allObjectRows.length > 10) {
        <button type="button" class="acv-show-more" (click)="toggleShowAll()">
          <i class="pi" [class.pi-chevron-down]="!showAllObjects" [class.pi-chevron-up]="showAllObjects"></i>
          {{ showAllObjects ? 'Ver menos' : 'Ver todos (' + allObjectRows.length + ')' }}
        </button>
      }
    </div>

  }

</div>
